exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#dashboard-modal-test-view .modal-btns{display:flex;flex-wrap:wrap}#dashboard-modal-test-view .modal-btn-wrapper{padding:10px}#dashboard-modal-test-view .modal-btn-wrapper>button{margin:0}#dashboard-modal-test-view .modal-closer{position:absolute;z-index:9999999999;top:10px;right:10px}", ""]);

